import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { useStore } from '../../../store';
import { BILLS_PAGE_SIZE, getFetchBillsAPIURL } from '../consts';

interface IProps {
  status: string;
  pageNumber: number;
  sortBy: string;
  sortDirection: string;
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
}

export const useFetchBills = (
  {
    status,
    pageNumber,
    sortBy,
    sortDirection,
    onSuccess,
    onError,
  } : IProps,
) => {
  const { user: { customerId }, getPersonalAccount } = useStore(state => state);

  const fetchBills = async () => {
    const apiURL = getFetchBillsAPIURL(customerId, getPersonalAccount().accountExternalId);
    const queryString = `status=${status}&pageSize=${BILLS_PAGE_SIZE}&pageNumber=${pageNumber}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
    const { data } = await httpService.get(`${apiURL}?${queryString}`);
    return data;
  };

  return useQuery(
    [`${status}_BILLS`],
    async () => fetchBills(),
    {
      onSuccess: (data:any) => {
        if (onSuccess) onSuccess(data);
      },
      onError: (error: any) => {
        if (onError) onError(error);
      },
      enabled: false,
      retry: 1,
    },
  );
};
